import { LinearProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { ImageViewerTabProps } from './ImageViewerTab.props';
import { useDocuments } from '../../../../services/hooks';
import ImageViewer from '../../../FileViewer/image-viewer/ImageViewer';
import { DEFAULT_DOC_CONTENT_STALE_TIME_IN_MS } from '../document-preview.constants';

export const ImageViewerTab = ({ document }: ImageViewerTabProps) => {
  const { downloadDocumentContent } = useDocuments();
  const { data, isLoading } = useQuery({
    queryKey: ['document', document.document_reference_id, 'content'],
    enabled: !!document.document_reference_id,
    staleTime: DEFAULT_DOC_CONTENT_STALE_TIME_IN_MS,
    queryFn: () => downloadDocumentContent(document),
  });

  if (isLoading) {
    return <LinearProgress />;
  }

  if (!data.content && !data.blob_url) {
    return <div>No document found</div>;
  }
  return <ImageViewer base64Content={data.content} src={data.blob_url} />;
};
